<template>
  <ais-pagination
    :padding="1"
    @page-change="pageChange"
  >
    <template #default="{ currentRefinement, nbPages, pages, isLastPage, refine, createURL }">
      <div
        v-if="nbPages > 1"
        class="display-flex tablet:display-none flex-content-center flex-wrap flex-items-center"
      >
        <a
          v-if="currentRefinement >= 1"
          :href="createURL(currentRefinement - 1)"
          aria-label="Previous Page"
          class="button flat clear"
          @click.prevent="refine(currentRefinement - 1)"
        >
          <font-awesome-icon
            :icon="$v6.solid.faAngleLeft"
            size="lg"
            class="margin-right-sm"
            aria-hidden="true"
          />
          Prev
        </a>
        <span style="padding: var(--button-padding); vertical-align: middle; border-style: solid; border-width: 0; margin-bottom: var(--button-margin-bottom)">
          Page {{ currentRefinement + 1 }}
        </span>
        <a
          v-if="!isLastPage"
          :href="createURL(currentRefinement + 1)"
          aria-label="Next Page"
          class="button flat clear"
          @click.prevent="refine(currentRefinement + 1)"
        >
          Next
          <font-awesome-icon
            :icon="$v6.solid.faAngleRight"
            size="lg"
            class="margin-left-sm"
            aria-hidden="true"
          />
        </a>
      </div>
      <div
        v-if="nbPages > 1"
        class="display-none tablet:display-flex flex-content-center flex-wrap flex-items-center pagination-large-screen"
        style="width: 100%"
      >
        <a
          v-if="currentRefinement > 1"
          :href="createURL(currentRefinement - 1)"
          aria-label="Previous Page"
          class="button flat clear"
          @click.prevent="refine(currentRefinement - 1)"
        >
          <font-awesome-icon
            :icon="$v6.solid.faAngleLeft"
            size="lg"
            class="margin-right-sm"
            aria-hidden="true"
          />
          Prev
        </a>
        <a
          v-if="currentRefinement > 1"
          :href="createURL(1)"
          class="button flat clear"
          @click.prevent="refine(0)"
        >
          1
        </a>
        <div
          v-if="currentRefinement > 1"
          class="padding-horizontal-3xs"
          style="
            --button-color: --body-color;
            padding: var(--button-padding);
            vertical-align: middle;
            border-style: solid;
            border-width: 0;
            margin-bottom: var(--button-margin-bottom);
          "
          aria-hidden="true"
        >
          ...
        </div>
        <button
          v-for="page in pages"
          :key="page"
          :class="[page === currentRefinement ? 'flat' : '', 'flat clear']"
          :style="[page === currentRefinement ? { background: 'var(--fa-dk-blue)', color: 'var(--white)' } : '']"
          @click.prevent="refine(page)"
        >
          {{ page + 1 }}
        </button>
        <div
          v-if="currentRefinement < nbPages - 2"
          class="padding-horizontal-3xs"
          style="
            --button-color: --body-color;
            padding: var(--button-padding);
            vertical-align: middle;
            border-style: solid;
            border-width: 0;
            margin-bottom: var(--button-margin-bottom);
          "
          aria-hidden="true"
        >
          ...
        </div>
        <div
          v-if="currentRefinement < nbPages - 2"
          style="
            --button-color: --body-color;
            padding: var(--button-padding);
            vertical-align: middle;
            border-style: solid;
            border-width: 0;
            margin-bottom: var(--button-margin-bottom);
          "
        >
          {{ nbPages }}
        </div>
        <a
          v-if="currentRefinement < nbPages - 2"
          :href="createURL(currentRefinement + 1)"
          aria-label="Next Page"
          class="button flat clear"
          @click.prevent="refine(currentRefinement + 1)"
        >
          Next
          <font-awesome-icon
            :icon="$v6.solid.faAngleRight"
            size="lg"
            class="margin-left-sm"
            aria-hidden="true"
          />
        </a>
      </div>
    </template>
  </ais-pagination>
</template>

<script>
  export default {
    name: 'IconsPagination',

    methods: {
      pageChange() {
        document.body.scrollIntoView()
        this.$emit('closeIcon')
      }
    }
  }
</script>
